import React, { useState, useEffect, useRef } from "react";
import { useLocalStorage } from '../../../../services/LocalStorageProvider';

export const AudioTaskDemonstration: React.FC<{ audioSrc: string; }> = ({ audioSrc }) => {
  const ref = useRef<HTMLAudioElement>(null);
  const { storage, updateStorage } = useLocalStorage();
  const isRecording = storage?.isRecording || false;
  const [hasBeenPlayed, setHasBeenPlayed] = useState(() => false);

  const stopPlayingAudio = () => {
    if (ref.current) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
  };

  useEffect(() => {
    updateStorage({ disableRecording: true });

    return () => {
      stopPlayingAudio();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isRecording) {
      stopPlayingAudio();
    }
  }, [isRecording]);

  useEffect(() => {
    if (hasBeenPlayed && storage.disableRecording) {
      updateStorage({ disableRecording: false });
    }
  }, [hasBeenPlayed, storage.disableRecording, updateStorage]);

  if (!audioSrc) {
    return null; // or return a placeholder if needed
  }

  return (
    <div className={`audio-task-demonstration ${isRecording ? 'disabled' : ''}`}>
      <audio
        ref={ref}
        src={audioSrc}
        preload="auto"
        controls
        onEnded={() => setHasBeenPlayed(true)} />
    </div>
  );
};
